import React, { useEffect } from 'react';
import WhoAreWe from './WhoAreWe';
import ContentPageLayout from './ContentPageLayout';

const WhoAreWePage: React.FC = () => {
    useEffect(() => {
        document.title = 'Our Story - DeliFeed';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'Learn about DeliFeed - a family-run Mediterranean food delivery service in Upper Cambourne. Fresh ingredients from our kitchen to your table.');
        }
    }, []);

    return (
        <ContentPageLayout title="Our Story">
            <WhoAreWe />
        </ContentPageLayout>
    );
};

export default WhoAreWePage;
